module.exports = __webpack_public_path__ + "img/9788980072026.4903d23c.jpg";